import { Directive, EventEmitter, Output } from '@angular/core';

export type SortDirection = 'asc' | 'desc' | '';

export interface Sort {
  active: string;
  direction: SortDirection;
}

@Directive({
    selector: '[customSort]',
    exportAs: 'customSort',
    standalone: false
})
export class CustomSortDirective {
  active: string;
  direction: SortDirection = '';

  @Output() sortChange = new EventEmitter<Sort>();

  sort(id: string): void {
    if (this.active !== id) {
      this.active = id;
      this.direction = 'asc';
    } else {
      this.direction = this.getNextDirection();
    }

    this.sortChange.emit({ active: this.active, direction: this.direction });
  }

  isSorted(id: string): boolean {
    return this.active === id && this.direction !== '';
  }

  private getNextDirection(): SortDirection {
    if (this.direction === 'asc') {
      return 'desc';
    }

    return this.direction === 'desc' ? '' : 'asc';
  }
}
